module.exports = __webpack_public_path__ + "img/squares-icon.83072128.svg";